const cardItems = [
  {
    title: '某顶流艺人被拍到深夜密会，工作室火速回应引热议',
    excerpt: '近日有媒体拍到某顶流艺人与神秘人士深夜同框，照片曝光后迅速登上热搜。工作室第一时间发布声明，但网友似乎并不买账，评论区争议持续发酵，相关话题阅读量已突破 5 亿。',
    tag: '娱乐圈',
    time: '3 小时前',
    hot: '爆',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20night%20scene%20with%20warm%20city%20lights%20and%20soft%20bokeh%20effect%2C%20dramatic%20atmospheric%20mood%2C%20crimson%20and%20amber%20tones%2C%20paparazzi%20style%20but%20abstract%2C%20no%20recognizable%20people%2C%20editorial%20photography%20feel&width=800&height=500&seq=card-01-bl&orientation=landscape',
  },
  {
    title: '知名科技公司内部邮件泄露：下季度将有大动作',
    excerpt: '一封据称来自某知名科技公司高管的内部邮件在网上流传，内容透露公司正在筹划一项足以改变行业格局的重大举措。业内人士分析认为，如果消息属实，将引发连锁反应。',
    tag: '科技圈',
    time: '5 小时前',
    hot: '热',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20corporate%20office%20scene%20with%20digital%20screens%20and%20geometric%20patterns%2C%20warm%20amber%20and%20dark%20red%20tones%2C%20modern%20tech%20aesthetic%2C%20soft%20atmospheric%20lighting%2C%20professional%20editorial%20style%2C%20no%20text%20or%20people%20faces&width=800&height=500&seq=card-02-bl&orientation=landscape',
  },
  {
    title: '社交平台因某话题服务器崩溃，运营团队紧急抢修',
    excerpt: '今日下午某社交平台因一则爆炸性爆料导致访问量激增，服务器一度出现大面积瘫痪。经过运维团队紧急抢修后逐步恢复，此事件再次引发关于平台承压能力的讨论。',
    tag: '互联网',
    time: '6 小时前',
    hot: '沸',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20digital%20network%20visualization%20with%20red%20warning%20and%20amber%20data%20flows%2C%20server%20room%20atmosphere%2C%20geometric%20patterns%2C%20dramatic%20lighting%2C%20modern%20tech%20aesthetic%2C%20no%20text&width=800&height=500&seq=card-03-bl&orientation=landscape',
  },
  {
    title: '体育明星转会传闻再起波澜，多方消息指向惊人去向',
    excerpt: '距离转会窗口关闭还有不到一周，一则关于某体育明星的重磅转会传闻突然爆发。多个消息源同时指向同一个惊人目的地，如果交易完成将打破多项历史纪录。',
    tag: '体育界',
    time: '8 小时前',
    hot: '热',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20sports%20arena%20atmosphere%20with%20dramatic%20spotlight%20effects%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20motion%20blur%20and%20energy%2C%20geometric%20composition%2C%20no%20text%20or%20recognizable%20people&width=800&height=500&seq=card-04-bl&orientation=landscape',
  },
  {
    title: '财经圈重磅：某上市公司被曝财务造假，股价盘中闪崩',
    excerpt: '今日盘中某上市公司突然被曝出财务数据存在严重问题，消息一出股价应声暴跌，盘中一度触发熔断机制。监管机构已表示将介入调查，市场恐慌情绪持续蔓延。',
    tag: '财经圈',
    time: '10 小时前',
    hot: '爆',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20financial%20market%20visualization%20with%20red%20declining%20graphs%20and%20dramatic%20data%20patterns%2C%20warm%20crimson%20and%20dark%20tones%2C%20geometric%20shapes%2C%20intense%20atmospheric%20lighting%2C%20no%20text&width=800&height=500&seq=card-05-bl&orientation=landscape',
  },
  {
    title: '国际局势突发变动：多方势力博弈引发全球关注',
    excerpt: '近日国际局势出现突发性变动，多国政要密集发声表态。分析人士指出，此次事件可能对全球格局产生深远影响，各方博弈仍在持续，后续发展值得密切关注。',
    tag: '国际',
    time: '12 小时前',
    hot: '热',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20global%20political%20scene%20with%20warm%20amber%20and%20deep%20red%20tones%2C%20geometric%20world%20map%20patterns%2C%20diplomatic%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20editorial%20style%2C%20no%20text&width=800&height=500&seq=card-06-bl&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            最新爆料
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时追踪每日热点，第一时间掌握最新动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((card, i) => (
            <div
              key={i}
              className="rounded-xl overflow-hidden bg-background-50 border border-background-200/60 transition-all hover:border-primary-200 cursor-pointer group"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold whitespace-nowrap">
                    {card.hot}
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-background-950/60 text-background-100 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-3">
                  {card.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="whitespace-nowrap">
                    <i className="ri-time-line mr-1"></i>{card.time}
                  </span>
                  <span className="whitespace-nowrap cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-share-forward-line mr-1"></i>分享
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}